import { useState } from "react";
import { ChatMessage } from "../../../../interfaces/chatbotInterface";
import { postChatMessage } from "../../../../api/chatbot";
import { Box, Button, CircularProgress, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import styles from "../../styles";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CheckIcon from '@mui/icons-material/Check';

type ChatMessageItemProps = {
  message: ChatMessage;
  isOldest: boolean;
  oldestMessageRef?: (node: HTMLDivElement | null) => void;
  onSuggestedClick: (query: string) => void;
};

const ChatMessageItem = ({ message, isOldest, oldestMessageRef, onSuggestedClick }: ChatMessageItemProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isQuerySaved, setIsQuerySaved] = useState(false);

  const handleSaveQuery = async () => {
    setIsLoading(true);
    try {
      await postChatMessage({ ...message, isReserved: true });
    } finally {
      setIsLoading(false);
      setIsQuerySaved(true);
    }
  };

  const renderSaveQueryButton = (message: ChatMessage) => {
    if (isQuerySaved) {
      return (
        <Tooltip title="Query Saved" placement="left">
          <IconButton
            size="small"
            color="primary"
            className="saveQueryBtn"
            sx={{ ...styles.saveQueryButton, ...styles.savedQueryButton }}
          >
            <CheckIcon sx={{ ...styles.saveQueryIcon }} />
          </IconButton>
        </Tooltip>
      );
    }
    return (
      <Tooltip title="Save Query" placement="left">
        <IconButton
          size="small"
          color="primary"
          onClick={handleSaveQuery}
          className="saveQueryBtn"
          sx={styles.saveQueryButton}
          disabled={isLoading}
        >
          {isLoading ? <CircularProgress size={20} /> : <SaveAltIcon sx={styles.saveQueryIcon} />}
        </IconButton>
      </Tooltip>
    );
  };

  return (
    <Box
      ref={isOldest ? oldestMessageRef : null}
      sx={message.senderType === "human" ? styles.messageRowUser : styles.messageRowBot}
    >
      {message.senderType === "human" && renderSaveQueryButton(message)}
      <Box sx={message.senderType === "human" ? styles.messageBubbleUser : styles.messageBubbleBot}>
        <Typography variant="body2" dangerouslySetInnerHTML={{ __html: message.content }} />
        {message.type === "options" && message.suggestedQueries && (
          <Stack spacing={1} mt={1}>
            {message.suggestedQueries.map((q, i) => (
              <Button
                key={i}
                fullWidth
                size="small"
                onClick={() => onSuggestedClick(q)}
                sx={styles.suggestedButton}
              >
                {q}
              </Button>
            ))}
          </Stack>
        )}
      </Box>
    </Box>
  );
};


export default ChatMessageItem;